import styled from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontBold, fontCondensed } from "@fdr/static-ui/Typography";
import Text from "@fdr/atomic-ui/_atoms/Text";
import { RunnerChance } from "./types";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 8px;
  align-items: center;

  & :last-of-type {
    padding-bottom: 0;
  }
`;

export const TextDerbyPickOdds = styled(Text)`
  font-size: 16px;
  color: ${buildColor("grey", "D4")};
  font-family: ${fontBold};
  font-weight: bold;
  line-height: 125%;
  font-style: normal;
`;

export const LeftSide = styled.div`
  display: flex;
  align-items: center;
`;

export const RunnerNumberWrapper = styled.div`
  margin-left: 6px;
  margin-right: 6px;
  height: fit-content;
  & > span {
    height: 14px;
  }
`;

const computeBackgroundColor = (chance: string): string => {
  switch (chance) {
    case "1st":
      return buildColor("green", "default");
    case "2nd":
      return buildColor("grey", "D3");
    case "3rd":
      return buildColor("orange", "D2");
    default:
      return "";
  }
};

export const HighlightedTextWrapper = styled.div<{
  chance: RunnerChance;
}>`
  height: fit-content;
  span {
    background-color: ${({ chance }) => computeBackgroundColor(chance)};
  }
`;

export const DerbyChanceHighlighted = styled.span`
  width: 40px;
  display: block;
  text-align: center;
  color: ${buildColor("white", "default")};
  font-family: ${fontCondensed};
  letter-spacing: 1px;
  line-height: 12px;
  font-size: 12px;
  padding-top: 2px;
  text-transform: uppercase;
`;
